/* tslint:disable */

declare var Object: any;
export interface ProductUomCategoryInterface {
  "id"?: number;
  "name": string;
}

export class ProductUomCategory implements ProductUomCategoryInterface {
  "id": number;
  "name": string;
  constructor(data?: ProductUomCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProductUomCategory`.
   */
  public static getModelName() {
    return "ProductUomCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProductUomCategory for dynamic purposes.
  **/
  public static factory(data: ProductUomCategoryInterface): ProductUomCategory{
    return new ProductUomCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProductUomCategory',
      plural: 'ProductUomCategories',
      path: 'ProductUomCategories',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ProductUomCategory.ts